(() => {
  const initTrustpilotWidgets = () => {
    const tpWidgets = document.querySelectorAll('.trustpilot-widget-section:not([data-tp-observed])');
    if (!tpWidgets.length) return;

    function loadWidget(element) {
      if (element.dataset.tpLoaded) return;

      const checkAndLoad = () => {
        if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
          element.dataset.tpLoaded = 'true';
          window.Trustpilot.loadFromElement(element);
          return true;
        }
        return false;
      };

      if (checkAndLoad()) return;

      // Listen to script load event to avoid active CPU polling
      const tpScript = document.querySelector('script[src*="tp.widget.bootstrap.min.js"]');
      if (tpScript) {
        tpScript.addEventListener('load', () => checkAndLoad(), { once: true });
      }

      // Gentle 250ms fallback polling for low-end devices
      const interval = setInterval(() => {
        if (checkAndLoad()) {
          clearInterval(interval);
        }
      }, 250);

      setTimeout(() => clearInterval(interval), 10000);
    }

    const tpObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadWidget(entry.target);
            tpObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '300px 0px 300px 0px' }
    );

    tpWidgets.forEach((widget) => {
      widget.dataset.tpObserved = 'true';
      tpObserver.observe(widget);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustpilotWidgets);
  } else {
    initTrustpilotWidgets();
  }

  // Re-run on dynamic updates (e.g. infinite scroll or collection filters)
  document.addEventListener('shopify:section:load', initTrustpilotWidgets);
})();
